export interface EinheitenLeerstand { gesamt: number; belegt: number; frei: number; }

/** Wohnt der Mieter (noch)? NULL gilt codebase-weit als aktiv; Gekündigte sind noch nicht ausgezogen. */
export function istWohnend(status: string | null | undefined): boolean {
  const s = (status || 'aktiv').toLowerCase();
  return s === 'aktiv' || s === 'gekündigt' || s === 'gekuendigt';
}

export function berechneLeerstand(gesamt: number, belegteIds: (string | null)[]): EinheitenLeerstand {
  const belegt = new Set(belegteIds.filter(Boolean)).size;
  return { gesamt, belegt, frei: Math.max(0, gesamt - belegt) };
}

/**
 * Leerstand fürs Dashboard – #596: dieselbe Rechnung wie die Immobilien-Übersicht (baueObjektZeilen + portfolio):
 * ohne archivierte Objekte und Verwaltungsobjekt, nur MV/SEV/GV und bei WEG nur SEV-Einheiten.
 * Zimmer (#499) zählen nicht einzeln: ein vermietetes Zimmer belegt seine Wohnung.
 */
export async function ladeEinheitenLeerstand(): Promise<EinheitenLeerstand> {
  const [{ ladeBestand }, { baueObjektZeilen, portfolio }] = await Promise.all([
    import('../immobilien/useObjektListe'), import('../immobilien/portfolio'),
  ]);
  const b = await ladeBestand();
  const p = portfolio(baueObjektZeilen(b.objekte, b.einheiten, b.mieter, b.sevEinheiten).filter(z => !z.archiviert));
  return { gesamt: p.mietEinheiten, belegt: p.belegt, frei: p.frei };
}
